module.exports = __webpack_public_path__ + "img/Weapon_10.1a868e9f.png";